export default "__VITE_ASSET__BC$3r9FL__"